import { render, staticRenderFns } from "./168.vue?vue&type=template&id=72df8d06&scoped=true&"
var script = {}
import style0 from "./168.vue?vue&type=style&index=0&id=72df8d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df8d06",
  null
  
)

export default component.exports